"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var ChildRows_meta_1 = require("./ChildRows.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var Row_1 = __importDefault(require("../Row"));

var mobx_1 = require("mobx");

var ChildRows =
/** @class */
function (_super) {
  __extends(ChildRows, _super);

  function ChildRows(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ChildRows_meta_1.CHILD_ROWS_CATEGORY_KEY;
    _this.componentKey = ChildRows_meta_1.CHILD_ROWS_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(ChildRows.prototype, "parentComponentKey", {
    get: function get() {
      return ChildRows_meta_1.CHILD_ROWS_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChildRows.prototype, "tableEventsKey", {
    get: function get() {
      return undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChildRows.prototype, "rows", {
    get: function get() {
      return this.props.rows || [];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChildRows.prototype, "grouping", {
    get: function get() {
      return this.props.grouping;
    },
    enumerable: true,
    configurable: true
  });

  ChildRows.prototype.render = function () {
    var _this = this;

    return react_1.default.createElement(react_1.Fragment, null, this.rows && this.rows.length > 0 && this.rows.map(function (row, rowIndex) {
      var key = _this.getRowKey(row, rowIndex);

      var childGrouping = _this.grouping && _this.grouping.childGroup;

      var rowStyleProps = _this.getRowStyleProps(row, rowIndex, childGrouping);

      return react_1.default.createElement(Row_1.default, __assign({}, rowStyleProps, {
        key: key,
        table: _this.table,
        row: row,
        rowIndex: rowIndex,
        grouping: childGrouping
      }));
    }));
  };

  __decorate([mobx_1.computed], ChildRows.prototype, "rows", null);

  __decorate([mobx_1.computed], ChildRows.prototype, "grouping", null);

  ChildRows = __decorate([mobx_react_1.observer], ChildRows);
  return ChildRows;
}(TableComponentBase_1.TableComponentBase);

exports.ChildRows = ChildRows;
exports.default = shared_1.InjectedStyledComponent(ChildRows, ChildRows_meta_1.CHILD_ROWS_CATEGORY_KEY, ChildRows_meta_1.CHILD_ROWS_PARENT_COMPONENT_KEY, [ChildRows_meta_1.CHILD_ROWS_COMPONENT_KEY]);